import { ChatDetailModel } from './../app-component/chat-detail/chat-detail.model'
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core'
import { AuthService } from '@services/auth.services'
import { HttpClient } from '@angular/common/http'
import { RestServices } from '@services/rest.services'
import { SharedServices } from '@services/shared.services'
import { ActivatedRoute, Router } from '@angular/router'
import { imageUrl } from '@helpers/common'
import { MatrixServices } from '@services/image/matrix.services'
import { StateServices } from '@services/state.services'
import { AppConfigService, ChatService, NotificationService, SocketService } from '@app/services'
import { ChatDetailComponent } from '../app-component/chat-detail/chat-detail.component'
import * as moment from 'moment'
import { notification } from 'onsenui'
import { environment } from '../../../environments/environment'
import MainConfig from '../../../config/main'


declare var cordova: any
declare var window: any

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ons-page[tabCommunication]',
    templateUrl: './communication.component.html',
    styleUrls: [
        '../../stagingcss/main-body.component.css',
        './communication.component.css',
        '../../stagingcss/lui-select.component.css',
        '../../stagingcss/radial-progress.component.css',
    ],
})
export class CommunicationComponent implements OnInit, OnDestroy {
    imageUrl = imageUrl
    en: any = {}
    showEN = true
    editMode = 0
    LIST_MODE = 0
    EDIT_MODE = 1
    clientId
    arrList: any[] = []
    getUserId
    pauseVideo = true
    loading = false
    showingImage = false
    chatTags = []
    chatTagsObj = {}
    visibleChatTags = []
    activeTag = ''
    sender
    updateData: any
    clientInfo: any

    enableBehavior: any = 'false'

    deleteData
    chatModel: ChatDetailModel
    @ViewChild(ChatDetailComponent) appChatDetail: ChatDetailComponent

    isCreate: boolean
    idUpdate: any
    locale: any
    idDivScroll
    listPatientSeenAt
    statusReadonly

    constructor(
        private ref: ChangeDetectorRef,
        private auth: AuthService,
        private router: Router,
        private stateServices: StateServices,
        private activatedRoute: ActivatedRoute,
        private restApi: RestServices,
        private _sharedService: SharedServices,
        private appConfigService: AppConfigService,
        public matrixServices: MatrixServices,
        private http: HttpClient,
        private socketService: SocketService,
        public chatService: ChatService,
        private notificationService: NotificationService,
    ) {
        this._sharedService.changeEmittedSource$.subscribe(success => {
            this.sender = success[0].firstName + success[0].familyName
        })

        chatService.closeChat$.subscribe(chatModel => {
            this.clean()
            this.listCommunicationId(this.clientId, true)

        })
    }

    ngOnInit() {
        this._sharedService.changeEmittedSource$.subscribe((success) => {
            this.clientInfo = success[0]
            this.clientId = this.clientInfo['_id']
        })
        this._sharedService.changeEmitted$.subscribe((success) => {
            if (success) {
                if (
                    (success[0] === 'changePageMobileApp' &&
                        success[2] === 'tabCommunication')
                    || (success[0] == 'changePageApp' && success[1] === 4)
                ) {
                    const dataUser = this.auth.getUser()

                    if (!this.clientId && dataUser.clientId) {
                        this.clientId = dataUser.clientId;
                    }
                        this.listCommunicationId(this.clientId)
                    this.listPatientSeenAt = ''
                } else {
                    this.editMode = this.LIST_MODE
                    this.visibleChatTags = []
                }
            }
        })
        this.locale = this.auth.getLocale()
        this.getUpdate()
        this.updateDateAfterDelete()
        this.changeLanguage()
    }

    updateDateAfterDelete() {
        this.deleteData = this.stateServices.changeEmittedDeleteTimeline$.subscribe(
            (res) => {
                if (res) {
                    this.listCommunicationId(this.clientId)
                    this.stateServices.emitChangeDeleteTimeline(null)
                }
            },
        )
    }

    getUpdate() {
        this.stateServices.emitChangeUpdateAligner(null)
        this.updateData = this.stateServices.changeEmittedUpdateAligner$.subscribe(
            (res) => {
                if (res) {
                    this.arrList = res['new']
                    this.arrList.sort(function(a, b) {
                        return b['visitDate'] - a['visitDate']
                    })
                    this.filterTags()
                    this.stateServices.emitChangeUpdateAligner(null)
                }
            },
        )
    }

    ngOnDestroy() {
        if(this.updateData)
            this.updateData.unsubscribe()
        if(this.deleteData)
            this.deleteData.unsubscribe()
    }

    // convert array of message tags to object
    convertTimelineTagsObject() {
        this.chatTagsObj = this.chatTags.reduce(function(acc, cur, i) {
            acc[cur._id] = cur.title
            return acc
        }, {})
    }

    changeActiveTag(item) {
        if (this.activeTag == item) {
            this.activeTag = null
        } else {
            this.activeTag = item
        }
        this.filterTags()
    }

    // filter timeline by message tag
    filterTags() {
        const result = []
        if (this.activeTag && this.arrList && this.arrList.length > 0) {
            this.arrList.forEach((item) => {
                if (item['tags'] && item['tags'].length > 0) {
                    if (item['tags'].indexOf(this.activeTag) != -1) {
                        result.push(item)
                    }
                }
            })
            this.visibleChatTags = result.map((x) => Object.assign({}, x))
        } else {
            this.visibleChatTags = this.arrList.map((x) =>
                Object.assign({}, x),
            )
        }
        this.visibleChatTags = this.visibleChatTags.sort(function(a, b) {
            return (b['createTime']) - (a['createTime'])
        })
        this.ref.detectChanges()
        this.changeLanguage()
    }

    changeLanguage() {
        return (this.en = this.auth.showLang(this.showEN))
    }

    // list timeline
    listCommunicationId(clientId, isLoadClose = false) {
        console.debug('START listCommunicationId', clientId)
        if (this.editMode == this.EDIT_MODE) {
            return
        }
        this.editMode = this.LIST_MODE
        this.activeTag = null
        const resourceUrl = 'resource'
        const map = {}
        map[clientId] = true
        const roomId = {}
        roomId['{"clientId":"' + clientId + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            status: {
                client: {
                    map,
                },
                clientCommunication: {
                    paths: roomId,
                    searches: roomId,
                },
            },
        })

        this.auth.authToken().then((tokenReNew) => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe((success) => {
                this.getUserId =
                    success['response']['staff']['paths']['{}']
                const listRoomMessage =
                    success['response']['clientCommunication']['searches'][
                    '{"clientId":"' + clientId + '"}'
                        ]
                this.arrList = listRoomMessage.sort(function(a, b) {
                    return b.visitDate - a.visitDate
                })
                if (this.appConfigService.chatTags) {
                    this.chatTags = this.appConfigService.chatTags
                    this.convertTimelineTagsObject()
                }

                this.updateClinicSeenAt(listRoomMessage, isLoadClose)
                this.filterTags()
            })
        })
    }

    private updateClinicSeenAt(listPatient, isLoadClose) {
        let actionsList = []
        for (let index = 0; index < listPatient.length; index++) {
            const element = listPatient[index]
            if (!element.patientSeenAt && element && !element.isPatientCreate) {
                actionsList.push({
                    type: 'update',
                    id: element._id,
                    collection: 'clientCommunication',
                    value: {
                        patientSeenAt: moment().utc().valueOf(),
                        updateTime: element.updateTime,
                    },
                })
            }
        }
        if (actionsList.length > 0) {
            const resourceData = this.restApi.makeResourceObject({
                actions: actionsList,
            })
            this.listPatientSeenAt = actionsList

            if (!isLoadClose) {
                this.auth.authToken().then(tokenReNew => {
                    this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                        if (success) {
                            //this.listPatientSeenAt = success['updateActions']
                            console.log(this.listPatientSeenAt)
                        }
                    })
                })
            }
        }
    }

    //
    createChat(key) {
        this.idDivScroll = null
        this.editMode = this.EDIT_MODE
        this.isCreate = true
        this.statusReadonly = false
        this.chatModel = new ChatDetailModel(key, true)
        this.appChatDetail.initForm(this.chatModel)
        this.appChatDetail.isCreate = true
    }

    //
    editChat(item, index) {
        this.isCreate = false
        this.statusReadonly = true
        this.editMode = this.EDIT_MODE
        this.idUpdate = item._id

        this.chatModel = item
        this.appChatDetail.initForm(this.chatModel)
        this.appChatDetail.isCreate = false
        this.idDivScroll = 'target_' + index
        setTimeout(() => {
            document.getElementById('target_0').scrollIntoView()
        }, 50)
    }

    showBigImage(event, id, matrix) {
        event.stopPropagation()
        this.showingImage = true
        const arrImage = [id, 'showBigImageDetailCommunication', matrix]
        this._sharedService.emitChange(arrImage)
    }

    onShowImage(index: any) {
        this.showingImage = true
        this.idDivScroll = 'target_' + index
    }

    closeBigImage() {
        console.debug('closeBigImage')
        this.showingImage = false
        this.scrollIntoView()
    }

    scrollIntoView() {
        if (this.idDivScroll != null) {
            setTimeout(() => {
                document.getElementById(this.idDivScroll).scrollIntoView()
            }, 50)
        }
    }

    closeEdit() {
        console.debug('discardEdit START')
        this.clean()
        this.scrollIntoView()
    }

    closeAndScrollToTarget = (value) => {
        if (value.communicationId) {
            this.clean()
            this.scrollIntoViewRootChat('chat_' + value.communicationId)
        }

    }

    scrollIntoViewRootChat(id) {
        if (id != null) {
            setTimeout(() => {
                document.getElementById(id).scrollIntoView()
            }, 50)
        }
    }

    discardEdit() {
        console.debug('discardEdit START')
        if (this.appChatDetail.hasChange) {
            notification.confirm({
                message: this.locale['alert-content-discard'],
                title: '<b>' + this.locale['alert-discard'] + '</b>',
                cancelable: false,
                buttonLabels: [
                    this.locale['alert-cancel'],
                    this.locale['alert-discard'],
                ],
                callback: (i) => {
                    // cancel
                    if (i === 0) {
                    } else if (i === 1) {
                        // discard
                        this.clean()
                    }
                },
            })
        } else {
            this.clean()
        }
        this.scrollIntoView()

    }

    clean() {
        // if (this.appChatDetail) {
        //     this.appChatDetail.clean()
        //     this.chatModel = null
        // }
        this.editMode = this.LIST_MODE
    }

    saveEdit() {
        console.debug('saveEdit START')
        if (
            this.appChatDetail.chatModel.isPatientCreate &&
            this.appChatDetail.validateForm()
        ) {
            const chatModel = this.appChatDetail.chatModel
            delete chatModel._id
            chatModel.clientId = this.clientId
            const clientId = {}
            clientId['{"clientId":"' + this.clientId + '"}'] = true
            const type = this.isCreate ? 'create' : 'update'
            const resourceData = this.restApi.makeResourceObject({
                actions: [
                    {
                        type: type,
                        id: this.isCreate ? null : this.idUpdate,
                        collection: 'clientCommunication',
                        value: chatModel,
                    },
                ],
                status: {
                    clientCommunication: {
                        paths: clientId,
                        searches: clientId,
                    },
                },
            })
            const chatUpdateData: any = { lastPatientCommunicationAt: moment().valueOf() }
            const actionUpdateClient = {
                collection: 'client',
                type: 'update',
                id: this.clientId ? this.clientId : null,
                value: chatUpdateData,
            }
            resourceData.actions.push(actionUpdateClient)
            this.editMode = this.LIST_MODE
            this.auth.authToken().then((tokenReNew) => {
                this.restApi
                .http_post('resource', resourceData, tokenReNew)
                .subscribe((success) => {
                    const payload = {
                        type: 'client-created-post',
                        url: `${ environment.baseUrl }/app/main/client/edit/${ this.clientId }/communication?modalId=${ success['updateActions'][0].id }`,
                        modalId: success['updateActions'][0].id,
                        clinic: this.auth.getUser(),
                        sender: this.sender,
                    }
                    if (MainConfig.ENABLE_WEB_NOTIFICATION) {
                        this.socketService.emitWebSocketEvent('communication notice', payload)
                        this.socketService.performPushWebNotification(payload)
                    }
                    this.listCommunicationId(this.clientId)
                })
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/communication/communication.component.ts